// Convert estimated weeks to a sequential calendar. The old generators changed
// durations for study hours but left every item in its original fixed month.
export function scheduleRoadmap(roadmap) {
  let elapsedWeeks = 0;
  const items = [...(roadmap.items || [])].sort((a,b) => (a.startMonth || a.month || 1) - (b.startMonth || b.month || 1)).map(item => {
    const duration = Math.max(1, Math.ceil(Number(item.duration) || 1));
    const startMonth = Math.floor(elapsedWeeks * 12 / 52) + 1;
    elapsedWeeks += duration;
    const endMonth = Math.max(startMonth, Math.ceil(elapsedWeeks * 12 / 52));
    return {...item,duration,startMonth,endMonth,month:startMonth,coveredInBootcamp:false};
  });
  return {...roadmap,items,totalMonths:Math.max(1,Math.ceil(elapsedWeeks * 12 / 52)),
    timelineMessage:'An estimated study plan, working through topics in sequence. Your pace can vary; this is not a job or salary forecast. Certification fees are estimates: check the provider before booking.',
    messageColor:'text-slate-300'};
}
